// extracted by mini-css-extract-plugin
module.exports = {"home":"Entry_home_dCRMN","audioPlayer":"Entry_audioPlayer_1AjTx"};